import script from "./FormSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormSection.vue?vue&type=script&setup=true&lang=ts"

import "./FormSection.vue?vue&type=style&index=0&id=6030f5b4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6030f5b4"]])

export default __exports__